import type { ApiResponse } from '@abaninja/types';

import { apiClient } from '@abaninja/util-http-client';

import type { Connection, GrantAccessRequest } from '../../@types';

export function grantAccess(connectionUuid: string, data: GrantAccessRequest) {
  return apiClient.post<ApiResponse<Connection>>(
    `/deep-cloud/v1/connections/${connectionUuid}/access`,
    data,
  );
}

export function revokeAccess(connectionUuid: string) {
  return apiClient.delete(`/deep-cloud/v1/connections/${connectionUuid}/access`);
}
